import { Button, Paragraph } from '@zillow/constellation-10';
import { IconPlusCircleFilled } from '@zillow/constellation-icons';

type Props = {
  displayText?: string;
  disabled?: boolean;
};

export const BigDropzone = ({ displayText, disabled }: Props) => (
  <>
    <Paragraph css={{ marginBlock: 'default' }}>{displayText ? displayText : 'Drag photos here'}</Paragraph>
    <Button size="sm" data-testid="BigDropzone-SelectFromComputer" disabled={disabled} icon={<IconPlusCircleFilled />}>
      Select from computer
    </Button>
  </>
);
